"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PriceRange = void 0;
var _culture = require("@ori/culture");
var _hooks = require("../../hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PriceRange = (param)=>{
    let { isBoldText, ...props } = param;
    const { minFee, maxFee } = (0, _hooks.usePriceRange)(props);
    const { translations } = (0, _hooks.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.PriceRangeWrapper, {
        ownerState: {
            isBoldText
        },
        children: [
            minFee === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.FreeLabel, {
                children: translations.free
            }) : minFee == null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
                children: minFee
            }),
            minFee != null && maxFee != null && minFee !== maxFee ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Separator, {}) : null,
            maxFee != null && minFee !== maxFee && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
                children: maxFee
            })
        ]
    });
};
exports.PriceRange = PriceRange;
